import { mlsGetStates } from '@/utils/helpers/';

const mlsGetStateValue = ( state: string ): string => {
    if ( state.length === 2 ) {
        return state.toUpperCase();
    } else {
        const states: Record<string, string> = mlsGetStates();
        for ( const fullName in states ) {
            if ( state === fullName.toLowerCase() ) {
                return states[ fullName ];
            }
        }
    }
    return state;
}
export default mlsGetStateValue;